// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import './libs/reset.css';
import axios from 'axios';
import VueQriously from 'vue-qriously';
import VueClipboard from 'vue-clipboard2';
import VideoPlayer from 'vue-video-player';
import '../static/jquery-1.8.3.min.js';
//require('video.js/dist/video-js.css')
//require('vue-video-player/src/custom-theme.css');

//require('videojs-contrib-hls/dist/videojs-contrib-hls');
Vue.use(VideoPlayer);
Vue.use(VueClipboard);
Vue.use(VueQriously);
Vue.config.productionTip = false;
Vue.prototype.$http = axios;

window.token = '';
// axios.defaults.baseURL = 'https://192.168.3.5:18080/';
axios.defaults.baseURL = 'https://www.mingyizhi.cn/mingyizhi/';

(axios.defaults.timeout = 50000000),
  //默认的contenttype为json以及utf-8；
  //axios.defaults.headers={'Content-Type': 'text/html;charset=gb2312'}
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  });



// WEBPACK FOOTER //
// ./src/main.js